import React, { useEffect, useState } from "react";
import { Package, Tag, Save, Loader2, X } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ExtraImagesPicker, readImage } from "@/components/ExtraImagesPicker";
import { toast } from "sonner";

function Slot({ label, icon: Icon, value, onChange, testId }) {
  const pick = async (e) => { const v = await readImage(e.target.files?.[0]); if (v) onChange(v); e.target.value = ""; };
  return (
    <div data-testid={testId}>
      <Label className="mb-1 block flex items-center gap-1"><Icon className="w-3.5 h-3.5 text-primary" /> {label}</Label>
      <div className="flex items-center gap-2">
        <label className="cursor-pointer flex-1">
          <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
          <div className="rounded-xl border border-dashed border-border bg-secondary py-2 text-center text-xs text-muted-foreground hover:border-primary/40 transition-colors">{value ? "تغيير" : "رفع صورة"}</div>
        </label>
        {value && (
          <div className="relative">
            <img src={value} alt="" className="w-11 h-11 rounded-lg object-contain border border-border bg-white/5" />
            <button type="button" onClick={() => onChange("")} className="absolute -top-1.5 -start-1.5 bg-destructive text-white rounded-full p-0.5" data-testid={`${testId}-remove`}><X className="w-3 h-3" /></button>
          </div>
        )}
      </div>
    </div>
  );
}

export function CampaignAssets({ campaign, onSaved }) {
  const [a, setA] = useState({ product_image: "", logo: "", extras: [] });
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setA({ product_image: "", logo: "", extras: [], ...(campaign?.assets || {}) }); setDirty(false); }, [campaign?.id]);
  const set = (patch) => { setA((p) => ({ ...p, ...patch })); setDirty(true); };
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/campaigns/${campaign.id}/assets`, a);
      setDirty(false);
      onSaved?.(data.assets);
      toast.success("تم حفظ مدخلات الحملة — ستُستخدم في كل توليد قادم");
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  if (!campaign) return null;
  return (
    <div className="glass rounded-2xl p-4 border border-border" data-testid="campaign-assets">
      <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
        <div>
          <h3 className="font-bold text-sm">مدخلات الحملة</h3>
          <p className="text-xs text-muted-foreground">صورة المنتج، صورة اسم العلامة، وصور إضافية — تُبنى عليها صور وفيديوهات هذه الحملة</p>
        </div>
        <Button size="sm" onClick={save} disabled={!dirty || saving} className="bg-primary hover:bg-primary/90 text-white gap-1" data-testid="campaign-assets-save">
          {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Save className="w-3.5 h-3.5" />} حفظ المدخلات
        </Button>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        <Slot label="صورة المنتج" icon={Package} value={a.product_image} onChange={(v) => set({ product_image: v })} testId="campaign-asset-product" />
        <Slot label="صورة اسم العلامة / الشعار" icon={Tag} value={a.logo} onChange={(v) => set({ logo: v })} testId="campaign-asset-logo" />
        <ExtraImagesPicker value={a.extras} onChange={(v) => set({ extras: v })} hint="" testId="campaign-asset-extras" />
      </div>
    </div>
  );
}
